import * as swcHelpers from '@swc/helpers';

const sortPowerOptions = (a, b)=>{
    return powerValueToFloat(a) - powerValueToFloat(b);
};
const powerToFloat = (power)=>{
    return powerValueToFloat(power === null || power === void 0 ? void 0 : power.value);
};
const powerValueToFloat = (powerValue)=>{
    return parseFloat(powerValue.replace(/[^\d.+-]/g, ''));
};
const getSortedArrayFromSet = (set, locale = undefined)=>{
    return Array.from(set).sort((a, b)=>a.localeCompare(b, locale, {
            numeric: true
        })
    ).map((item)=>({
            label: item.toString(),
            value: item
        })
    );
};
const getFilterOptions = (options = [])=>{
    const arr = options instanceof Set ? getSortedArrayFromSet(options) : options;
    return arr.reduce((prev, curr)=>{
        prev[curr.label] = curr.value;
        return prev;
    }, {});
};
const formatPowerValues = (values)=>{
    return getSortedArrayFromSet(values).map(({ value  })=>({
            label: value,
            value
        })
    ).sort((a, b)=>powerToFloat(a) - powerToFloat(b)
    );
};
const getEyeLabel = (intl, id)=>intl.getLabel(`products.${id === 'left' ? 'contactLenses.leftEye' : 'contactLenses.rightEye'}`)
;
const getAttributeLabel = (intl, attribute)=>intl.getLabel(`products.contactLenses.prescription.${attribute}`)
;
const mapLensesToDraftLineItem = (lineItems, type)=>{
    return lineItems.map(({ sku , quantity , custom , customAttributes , isQuantityDiscountSelected  })=>({
            sku,
            quantity,
            type,
            isQuantityDiscountSelected,
            typeDetails: swcHelpers.objectSpread({}, custom, customAttributes)
        })
    );
};

export { formatPowerValues, getAttributeLabel, getEyeLabel, getFilterOptions, getSortedArrayFromSet, mapLensesToDraftLineItem, powerToFloat, powerValueToFloat, sortPowerOptions };
//# sourceMappingURL=utils.js.map
